import React, { useState } from "react";
import { InputSearch } from "../../common/components/modals/InputSearch";
import { Overlay } from "../../common/components/modals/Overlay";
import useRoles from "../../common/roles/useRoles";
import { getCriteriaToFilter, visibleOnUserInput } from "../utils";
import { AdvancedSearchFooter, AdvancedSearchFooterProps } from "./AdvancedSearchFooter";
import { AdvancedSearchModalGroup } from "./AdvancedSearchModalGroup";
import {
	criteriaGroupsType,
	criteriaGroupType,
	notDeletableType,
	searchTitleType,
} from "../../common/types/search/search";

interface AdvancedSearchModalProps extends AdvancedSearchFooterProps {
	criteria: criteriaGroupsType;
	notDeletable?: notDeletableType;
	searchTitle: searchTitleType;
}

export function AdvancedSearchModal({
	criteria,
	notDeletable,
	searchTitle,
	...props
}: AdvancedSearchModalProps) {
	const { roles } = useRoles();
	const criteriaToFilter = getCriteriaToFilter(criteria, roles).flat();
	const [visibleCriteria, setVisibleCriteria] = useState(criteriaToFilter);
	const hasVisibleCriteria = (group: criteriaGroupType) =>
		Object.keys(group.criteria).some((key) =>
			visibleCriteria.some((item) => item.key === key),
		);

	const handleSearchInputChange = (input: string) => {
		const visible = criteriaToFilter.filter((item) =>
			visibleOnUserInput(item.label, input),
		);
		setVisibleCriteria(visible);
	};

	const title = "Advanced " + searchTitle;

	return (
		<Overlay
			title={title}
			additionalClasses="advanced-search-overlay"
			searchInput={InputSearch.add(
				"search-criteria-filter",
				"Search option name",
				"Enter search option name",
				"No search criteria found.",
				visibleCriteria.length,
				handleSearchInputChange,
			)}
		>
			<div className="search-criteria modal__content">
				{criteria.map(
					(group) =>
						hasVisibleCriteria(group) && (
							<AdvancedSearchModalGroup
								key={group.name}
								group={group}
								notDeletable={notDeletable}
								visibleCriteria={visibleCriteria}
							/>
						),
				)}
			</div>

			<AdvancedSearchFooter {...props} />
		</Overlay>
	);
}
